import { Color } from '@diritto/common/style/color';
import { FilledNewIconProps, NewIconProps } from '@diritto/common/style/icon';

interface NotiNewIconProps extends NewIconProps {
  opacity?: number;
}

const NotiOutlineIcon = ({ className, color = Color.Gray700, opacity }: NotiNewIconProps) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    fillOpacity={opacity}
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 16.08V11C18.9983 9.40534 18.4522 7.85905 17.452 6.61703C16.4519 5.37501 15.0576 4.51171 13.5 4.17V3.5C13.5 3.10218 13.342 2.72064 13.0607 2.43934C12.7794 2.15803 12.3978 2 12 2C11.6022 2 11.2206 2.15803 10.9393 2.43934C10.658 2.72064 10.5 3.10218 10.5 3.5V4.17C8.94238 4.51171 7.54812 5.37501 6.54796 6.61703C5.5478 7.85905 5.00169 9.40534 5 11V16.08L3 17.97V18.97H21V17.97L19 16.08ZM17 17H7V11C7 9.67392 7.52678 8.40215 8.46447 7.46447C9.40215 6.52678 10.6739 6 12 6C13.3261 6 14.5979 6.52678 15.5355 7.46447C16.4732 8.40215 17 9.67392 17 11V17ZM9.55 20H14.45C14.3352 20.5651 14.0286 21.0732 13.5821 21.4382C13.1356 21.8031 12.5767 22.0025 12 22.0025C11.4233 22.0025 10.8644 21.8031 10.4179 21.4382C9.97136 21.0732 9.66476 20.5651 9.55 20Z"
      fill={color}
    />
  </svg>
);

const NotiFilledIcon = ({ className, color = Color.Gray700, opacity }: NotiNewIconProps) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    fillOpacity={opacity}
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 16.08V11C18.9983 9.40534 18.4522 7.85905 17.452 6.61703C16.4519 5.37501 15.0576 4.51171 13.5 4.17V3.5C13.5 3.10218 13.342 2.72064 13.0607 2.43934C12.7794 2.15803 12.3978 2 12 2C11.6022 2 11.2206 2.15803 10.9393 2.43934C10.658 2.72064 10.5 3.10218 10.5 3.5V4.17C8.94238 4.51171 7.54812 5.37501 6.54796 6.61703C5.5478 7.85905 5.00169 9.40534 5 11V16.08L3 17.97V18.97H21V17.97L19 16.08ZM9.55 20H14.45C14.3352 20.5651 14.0286 21.0732 13.5821 21.4382C13.1356 21.8031 12.5767 22.0025 12 22.0025C11.4233 22.0025 10.8644 21.8031 10.4179 21.4382C9.97136 21.0732 9.66476 20.5651 9.55 20Z"
      fill={color}
    />
  </svg>
);

export const NotiIcon = ({ fill, fillColor, color, opacity, className }: FilledNewIconProps & NotiNewIconProps) =>
  fill ? (
    <NotiFilledIcon color={fillColor} className={className} />
  ) : (
    <NotiOutlineIcon color={color} opacity={opacity} className={className} />
  );
